import * as React from 'react';

function SvgChatbox(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M7 21.571a.714.714 0 01-.714-.714V18H5.214A3.218 3.218 0 012 14.786V6.214A3.218 3.218 0 015.214 3h13.572A3.218 3.218 0 0122 6.214v8.572A3.218 3.218 0 0118.786 18h-7.244l-4.084 3.406A.716.716 0 017 21.57z" })));
}

export default SvgChatbox;
